import { useSearchParams } from "react-router-dom";
import { LeadProfile } from "./leadProfile";

export default function LeadProfileOut() {
  const [searchParams] = useSearchParams();
  let id = 0;
  try {
    const raw = searchParams.get("") || searchParams.get("id") || "0";
    // 兼容 JSON 格式参数: ?{"id":123} 或 ?id=123
    if (raw.startsWith("{")) {
      const data = JSON.parse(decodeURIComponent(raw));
      id = data.id || 0;
    } else {
      id = Number(raw) || 0;
    }
  } catch {
    // 解析失败保持 id=0
  }

  return (
    <LeadProfile
      leadId={id}
      onClose={() => window.close()}
    />
  );
}
